import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id 0CE60AA4-FF6E-4899-AE30-830BD1E4F898
 * name land-rows-vertical
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/land-rows-vertical.svg
 * tags
 * - Agriculture 
 */
export const LandRowsVerticalIcon = createSvgIcon(<><path d="M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M6.5 20H4V4H6.5V20M11 20H8.5V4H11V20M15.5 20H13V4H15.5V20M20 20H17.5V4H20V20Z" /></>, 'LandRowsVerticalIcon');
export default LandRowsVerticalIcon